import BigPlayButton, { BigPlayButtonProps } from './BigPlayButton';

export default BigPlayButton;
export type { BigPlayButtonProps };
